import React from "react";
import { RouteProps } from "react-router-dom";

import ISidebarService from "../services/ISidebarService";

import SidebarMenuItem from "../models/SidebarMenuItem";

// import modules (pages)
import Contracts, { IContractsProps } from "features/contracts/Contracts";
import Customer from "features/customer/Customer";
import Dashboard from "features/dashboard/Dashboard";
import Payments from "features/payments/Payments";
import Requirements from "features/requirements/Requirements";
import Invoices from 'features/invoices/Invoices';
import ContractualAccounts from 'features/contractualAccounts/ContractualAccounts';
import SelfReadingDocs from 'features/selfReadings/SelfReadingDocs';
import ProformaInvoices from 'features/invoices/ProformaInvoices';
import TermsAndConditions from "features/conditions/TermsAndConditions";
import ConsumptionHistory from "features/consumption/ConsumptionHistory";
import ProductionHistory from "features/consumption/ProductionHistory";
import FuelingContracts from "features/contracts/FuelingContracts";
import ChargningHistory from "features/fueling/ChargningHistory";
import Contracting from "features/contracting/Contracting";
import Exports from "features/exports/Exports";

interface IProps {
  menuItems: SidebarMenuItem[];
}

interface ComponentMap {
  [key: string]: React.FC<IProps> | React.FC<IContractsProps>;
}

const createModuleRegistry = (): ComponentMap => {
  return {
    Contracts: Contracts,
    Customer: Customer,
    Dashboard: Dashboard,
    Payments: Payments,
    Requirements: Requirements,
    Invoices: Invoices,
    ContractualAccounts: ContractualAccounts,
    SelfReadingDocs: SelfReadingDocs,
    ProformaInvoices: ProformaInvoices,
    TermsAndConditions: TermsAndConditions,
    ConsumptionHistory: ConsumptionHistory,
    ProductionHistory: ProductionHistory,
    EmobilityContracts: FuelingContracts,
    ChargningHistory: ChargningHistory,
    Contracting: Contracting,
    Exports: Exports
  };
};

export const moduleRoutes = (
  menuItems: SidebarMenuItem[],
  sidebarService: ISidebarService
) => {
  let result: RouteProps[] = [];
  let moduleRegistry = createModuleRegistry();
  let itemsToRegistration = sidebarService.getMenuItemsToRegistration(
    menuItems
  );

  for (const item of itemsToRegistration) {
    let route: RouteProps = {
      exact: item.routePath === "/", // root path (Dashboard) must be exact
      path: sidebarService.getRouteWithParams(
        item.routePath,
        item.routeParams,
        true
      ),
      component: moduleRegistry[item.moduleName!],
    };
    result.push(route);
  }

  return result;
};

export default moduleRoutes;
